import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const IndexFilter = ({ label = "l.searchFilter.index", ...others }: FilterLabelProps) => {
  return <BaseInputFieldFilter type={"number"} fieldName={"index"} label={label} {...others} />;
};

export default IndexFilter;
